module.exports = __webpack_public_path__ + "static/media/angle-double-down.04e52341.svg";